module.exports = (v) => v !== undefined && v !== null;
